import $ from 'jquery';

window.$ = $;
window.jQuery = $;

import './lib/parsley.min.js';
import * as datePickers from './components/datepickers';
import * as mobileNav from './components/mobile-nav';

datePickers.init('link', '.js-datetime-picker-link');
datePickers.init('link', '.js-datetime-picker-link-sec');
datePickers.init('future', '.js-datetime-next-picker');

mobileNav.init();


/*
 *   COMPONENTS SCRIPTS
 */
import * as bannerVideos from './functions/bannerVideos';
import * as customForm from './functions/customForm';
import * as menuIndicator from './functions/menuIndicator';
// import * as mobileSwitchNav from './functions/mobileSwitchNav';
import * as counters from './functions/counters';
import * as whyOxSlider from './functions/whyOxSlider';
import * as testimonialsSlider from '././functions/testimonialsSlider';
import * as slickSlider from './functions/slickSlider';
import * as triggerNextElements from './functions/triggerNextElements';
//import * as datePickers from './functions/datePickers';
import * as audioPlay from './functions/audioPlay';
import * as clearInputs from './functions/clearInputs';
import * as requireInputsCondition from './functions/requireInputsCondition';
import * as clickActive from './functions/clickActive';
import * as galleryVideos from './functions/galleryVideos';
import * as boxVideos from './functions/boxVideos';
import * as moveItems from './functions/moveItems';
import * as socialShare from './functions/socialShare';
import * as checkboxChangeState from './functions/checkboxChangeState';
import * as inputFiles from './functions/inputFiles';
import * as oxRotatePlatform from './functions/oxRotatePlatform';
import * as changeHeader from './functions/changeHeader';
//import * as scrollMagic from './functions/scrollMagic';
import * as goToNextSection from './functions/goToNextSection';
import * as triggerMobileMenu from './functions/triggerMobileMenu';
import * as triggerIsActiveClass from './functions/triggerIsActiveClass';
import * as animateAEsvgs from './functions/animateAEsvgs';
import * as videoGalleryFilters from './functions/videoGalleryFilters';
import * as newsFilters from './functions/newsFilters';
import * as addIsActiveNavElem from './functions/addIsActiveNavElem';
import * as sliderTitles from './functions/sliderTitles';
import * as triggerFormModalBanner from './functions/triggerFormModalBanner';
import * as triggerSpecialFormModal from './functions/triggerSpecialFormModal';
import * as skipToSection from './functions/skipToSection';
import * as triggerSingleModal from './functions/triggerSingleModal';
import * as changeNewsHeaderView from './functions/changeNewsHeaderView';
import * as triggerFormCheckField from './functions/triggerFormCheckField';
import * as triggerFormCheckForm from './functions/triggerFormCheckForm';
import * as triggerNextCheckbox from './functions/triggerNextCheckbox';
import * as scrollToPosts from './functions/scrollToPosts';
import * as dropdown from './functions/dropdown';
import * as formMap from './functions/formMap';
import * as openVideoAtStart from './functions/openVideoAtStart';
import * as copyButton from './functions/copyButton';
import * as ajaxProjects from './functions/ajaxProjects';
import * as iconArrowBanner from './functions/iconArrowBanner';
import * as paverScript from './functions/paver';
import * as alternative from './functions/alternative';

/*
 *   INITIALIZE SCRIPTS
 */
const isIe = $('body').hasClass('internet-explorer');

$(function () {

    // skipToSection.init();

    socialShare.init('.js-social-share-btn');

    socialShare.init('.js-social-share-btn');

    if (!isIe) {
        counters.init('.js-count-number:not(.initialized)');
    } else {
        counters.ieFix('.js-count-number:not(.initialized)');
    }

    whyOxSlider.init('.js-why-ox-slider');

    testimonialsSlider.init('.js-testimonials-slider');

    slickSlider.arrows('.js-init-partners-slider');

    slickSlider.arrows('.js-init-text-image-slider', true);

    slickSlider.integrationSlider('.js-integration-items-slider');

    slickSlider.clients('.js-clients-slider');

    slickSlider.arrows('.js-init-full-gallery-slider');

    if($(window).width() <= 768) {
        slickSlider.arrowsAndDots('.js-small-init-slick');
    }

    menuIndicator.init('.js-menu-indicator');

    //mobileSwitchNav.init('.js-mobile-switch-nav');

    //customForm.customValidation();

    customForm.init('.js-sign-up-form');

    customForm.init('.js-timelapse-form');

    customForm.init('.js-cameras-form');

    customForm.init('.js-banner-form');

    customForm.init('.js-application-form');

    customForm.init('.js-validate-custom-box-form');

    // custom js for timelapse form
    customForm.initTimeplapseForm();

    triggerNextElements.init('.js-trigger-next');

    triggerNextElements.scroll('.js-show-next');

    datePickers.init('link', '.js-datetime-picker-link');

    datePickers.init('link', '.js-datetime-picker-link-sec');

    datePickers.init('future', '.js-datetime-next-picker');

    audioPlay.play('.js-audio-track');

    clearInputs.init('.js-remove-after-check');

    alternative.init('.show-alternative-email');

    moveItems.init('.js-move-to');

    requireInputsCondition.init('.js-condition-inputs');

    clickActive.init('.js-click-active');

    clickActive.parent('.js-trigger-social-share');

    checkboxChangeState.timelapseForm('.js-checkbox-id-show');

    window.players = [];

    bannerVideos.init('.js-section-video');
    bannerVideos.initClicks('.js-banner-video', '.js-section-video');
    bannerVideos.initWindowClicks('.js-section-video');

    galleryVideos.init('.js-trigger-gallery-video');

    boxVideos.init('.js-trigger-box-video');

    inputFiles.init();

    oxRotatePlatform.init('.js-rotate-circle-slick');

    //scrollMagic.init();

    changeHeader.run('.js-site-header');

    goToNextSection.init('.js-go-to-next-section');

    triggerMobileMenu.init('#main-menu-mobile');

    triggerIsActiveClass.init('.js-trigger-term-elem');

    // animateAEsvgs.init('.js-animated-icon-svg-ae');

    animateAEsvgs.gif('.js-animated-gif-at-hover');

    videoGalleryFilters.init('.js-video-gallery-with-filters');

    newsFilters.init('.js-news-filters');

    addIsActiveNavElem.init('.js-menu-indicator-secondary');

    sliderTitles.init('.js-slider-titles');

    triggerFormModalBanner.init('.js-trigger-modal-mobile');

    triggerSpecialFormModal.init('.js-trigger-special-form');

    triggerSingleModal.init('#subscribeButton');

    changeNewsHeaderView.init('.js-trigger-change-news-header-right');

    triggerFormCheckField.init('.js-trigger-input-field');

    triggerFormCheckForm.init('.js-trigger-special-hover');

    triggerNextCheckbox.init('.js-trigger-next-checkbox');

    scrollToPosts.init('.js-pagination-indicator');

    dropdown.init('.js-dropdown');

    formMap.init('.js-trigger-map-form');

    copyButton.init('.js-copy-button-function');

    ajaxProjects.init('.js-ajax-projects');

    iconArrowBanner.init('.js-icon-down-arrow');

    paverScript.init('.js-paver-image');
});
